export function CalendarAddFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M8 3a1 1 0 011 1v1h6V4a1 1 0 112 0v1h1a3 3 0 013 3v2H3V8a3 3 0 013-3h1V4a1 1 0 011-1z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 12v6a3 3 0 003 3h6.528A6 6 0 1021 12.528V12h-.682c-.95-.632-2.091-1-3.318-1a5.973 5.973 0 00-3.318 1H3zm14 1a1 1 0 011 1v2h2a1 1 0 110 2h-2v2a1 1 0 11-2 0v-2h-2a1 1 0 110-2h2v-2a1 1 0 011-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
